/**
 * @generated SignedSource<<f0d32c5b28883d9251aebd7a3b4decfb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RecoverToVersionInput = {
  clientMutationId?: string | null;
  noteId: string;
  version: number;
};
export type historyRecoverMutation$variables = {
  input: RecoverToVersionInput;
};
export type historyRecoverMutation$data = {
  readonly recoverToVersion: {
    readonly ok: boolean;
  } | null;
};
export type historyRecoverMutation = {
  response: historyRecoverMutation$data;
  variables: historyRecoverMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RecoverToVersionPayload",
    "kind": "LinkedField",
    "name": "recoverToVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "historyRecoverMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "historyRecoverMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "77c4abd4e19f84b5bbe516c80cc0c410",
    "id": null,
    "metadata": {},
    "name": "historyRecoverMutation",
    "operationKind": "mutation",
    "text": "mutation historyRecoverMutation(\n  $input: RecoverToVersionInput!\n) {\n  recoverToVersion(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ec63c840cb57330eb17e67c2babcccc";

export default node;
